module.exports = __webpack_public_path__ + "img/3-en.cd347b0f.png";